import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
// import getBaseUrl from '../getBaseUrl';
import { showSnackbar } from "./snackbar";
import { getApiErrorMessage } from "../../utils/apiError";
import { BASE_URL, getBaseUrl } from "../config";
import { getAuthApiHeaders } from "../../utils/common";
import secureLocalStorage from "react-secure-storage";
const baseUrl = getBaseUrl();
export const postUserChat = createAsyncThunk(
  "postUserChat",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(
        `${baseUrl}/user_session/${payload.sessionId}/chat`,
        payload.data,
        {
          headers: {
            "Content-Type": "application/json",
            "use-case": "src",
            ...getAuthApiHeaders({ includeIncomingEmail: true }),
          },
          withCredentials: true,
        },
      );
      return response.data;
    } catch (error) {
      dispatch(showSnackbar({ message: "Failed to load!", severity: "error" }));
      return rejectWithValue(getApiErrorMessage(error));
    }
  },
);
const userChatSlice = createSlice({
  name: "user-chat",
  initialState: {
    isLoading: false,
    userChat: [],
    isError: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(postUserChat.pending, (state, action) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(postUserChat.fulfilled, (state, action) => {
      state.isLoading = false;
      state.userChat = action.payload;
    });
    builder.addCase(postUserChat.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    });
  },
});

export default userChatSlice.reducer;
